import { defineComponent as J, ref as S, toRef as K, computed as a, withDirectives as Q, openBlock as l, createElementBlock as d, normalizeClass as h, unref as t, renderSlot as n, createCommentVNode as s, createBlock as c, resolveDynamicComponent as b, normalizeStyle as f, withCtx as I, Fragment as X, renderList as Y, mergeProps as Z, createVNode as ee } from "vue";
import { useWindowScroller as te } from "./composables/useWindowScroller.js";
import { _ as ie, R as le, O as re } from "./scroller.css_vue_type_style_index_0_src_true_lang--7gJ3zh_.js";
import { r as se } from "./useRecycleScroller-D_RDrEg2.js";
const fe = /* @__PURE__ */ J({
  __name: "WindowScroller",
  props: {
    items: {},
    keyField: { default: "id" },
    direction: { default: "vertical" },
    listTag: { default: "div" },
    itemTag: { default: "div" },
    itemSize: { default: null },
    gridItems: { default: void 0 },
    itemSecondarySize: { default: void 0 },
    minItemSize: { default: null },
    sizeField: { default: "size" },
    typeField: { default: "type" },
    buffer: { default: 200 },
    shift: { type: Boolean, default: !1 },
    cache: { default: void 0 },
    prerender: { default: 0 },
    emitUpdate: { type: Boolean, default: !1 },
    disableTransform: { type: Boolean, default: !1 },
    flowMode: { type: Boolean, default: !1 },
    hiddenPosition: { default: void 0 },
    updateInterval: { default: 0 },
    itemsLimit: { default: void 0 },
    enabled: { type: Boolean, default: !0 },
    listClass: { default: "" },
    itemClass: { default: "" }
  },
  emits: ["resize", "visible", "hidden", "update"],
  setup(k, { expose: T, emit: C }) {
    const e = k, o = C, F = re, m = S(), g = S(), z = S(), $ = K(e, "items"), V = a(() => ({
      items: $,
      el: m,
      before: g,
      after: z,
      keyField: e.keyField,
      direction: e.direction,
      itemSize: e.itemSize,
      gridItems: e.gridItems,
      itemSecondarySize: e.itemSecondarySize,
      minItemSize: e.minItemSize,
      sizeField: e.sizeField,
      typeField: e.typeField,
      buffer: e.buffer,
      shift: e.shift,
      cache: e.cache,
      prerender: e.prerender,
      emitUpdate: e.emitUpdate,
      disableTransform: e.disableTransform,
      flowMode: e.flowMode,
      hiddenPosition: e.hiddenPosition,
      updateInterval: e.updateInterval,
      itemsLimit: e.itemsLimit,
      enabled: e.enabled,
      onResize: () => o("resize"),
      onVisible: () => o("visible"),
      onHidden: () => o("hidden"),
      onUpdate: (i, w, r, v) => o("update", i, w, r, v)
    })), B = te(
      V
    ), {
      pool: M,
      totalSize: O,
      startSpacerSize: u,
      endSpacerSize: p,
      ready: _,
      scrollToItem: P,
      scrollToPosition: R,
      getScroll: x,
      findItemIndex: L,
      getItemOffset: N,
      getItemSize: U,
      getViewStyle: W,
      cacheSnapshot: D,
      restoreCache: H,
      updateVisibleItems: E,
      handleResize: j,
      handleVisibilityChange: q
    } = B, y = a(
      () => se({
        direction: e.direction,
        disableTransform: e.disableTransform,
        flowMode: e.flowMode,
        gridItems: e.gridItems
      }) === "flow"
    ), A = a(() => ({
      height: `${u.value}px`
    })), G = a(() => ({
      height: `${p.value}px`
    }));
    return T({
      el: m,
      startSpacerSize: u,
      endSpacerSize: p,
      scrollToItem: P,
      scrollToPosition: R,
      getScroll: x,
      findItemIndex: L,
      getItemOffset: N,
      getItemSize: U,
      cacheSnapshot: D,
      restoreCache: H,
      updateVisibleItems: E
    }), (i, w) => Q((l(), d("div", {
      ref_key: "el",
      ref: m,
      class: h(["vue-recycle-scroller vue-window-scroller", {
        "flow-mode": y.value,
        ready: t(_),
        [`direction-${e.direction}`]: !0
      }])
    }, [
      i.$slots.before ? (l(), d("div", {
        key: 0,
        ref_key: "before",
        ref: g,
        class: "vue-recycle-scroller__slot"
      }, [
        n(i.$slots, "before")
      ], 512)) : s("", !0),
      (l(), c(b(e.listTag), {
        style: f({ [e.direction === "vertical" ? "minHeight" : "minWidth"]: `${t(O)}px` }),
        class: h(["vue-recycle-scroller__item-wrapper", e.listClass])
      }, {
        default: I(() => [
          y.value && t(u) > 0 ? (l(), c(b(e.itemTag), {
            key: 0,
            "aria-hidden": "true",
            class: "vue-recycle-scroller__item-spacer",
            style: f(A.value)
          }, null, 8, ["style"])) : s("", !0),
          (l(!0), d(X, null, Y(t(M), (r) => (l(), c(ie, {
            key: r.nr.id,
            view: r,
            "item-tag": e.itemTag,
            style: f(t(_) ? t(W)(r) : null),
            class: h(["vue-recycle-scroller__item-view", e.itemClass])
          }, {
            default: I((v) => [
              n(i.$slots, "default", Z({ ref_for: !0 }, v))
            ]),
            _: 2
          }, 1032, ["view", "item-tag", "style", "class"]))), 128)),
          y.value && t(p) > 0 ? (l(), c(b(e.itemTag), {
            key: 1,
            "aria-hidden": "true",
            class: "vue-recycle-scroller__item-spacer",
            style: f(G.value)
          }, null, 8, ["style"])) : s("", !0),
          e.items.length === 0 ? n(i.$slots, "empty", { key: 2 }) : s("", !0)
        ]),
        _: 3
      }, 8, ["style", "class"])),
      i.$slots.after ? (l(), d("div", {
        key: 1,
        ref_key: "after",
        ref: z,
        class: "vue-recycle-scroller__slot"
      }, [
        n(i.$slots, "after")
      ], 512)) : s("", !0),
      ee(le, { onNotify: t(j) }, null, 8, ["onNotify"])
    ], 2)), [
      [t(F), t(q)]
    ]);
  }
});
export {
  fe as _
};
//# sourceMappingURL=WindowScroller.vue_vue_type_script_setup_true_lang-C3nM_XUB.js.map
